import React from 'react';
import ReactMarkdown from 'react-markdown';
import { format } from 'date-fns';
import type { Post } from '../api/types';
import Comments from './Comments';

interface BlogPostProps {
  post: Post;
}

function displayDate(post: Post): string {
  const raw = post.date || post.createdAt;
  try {
    return format(new Date(raw), 'MMMM dd, yyyy');
  } catch {
    return '';
  }
}

const BlogPost: React.FC<BlogPostProps> = ({ post }) => {
  const isShort = post.kind === 'short';

  return (
    <>
      <article className={`blog-post${isShort ? ' blog-post--short' : ''}`}>
        <header className="blog-post-header">
          <h1 className="blog-title">{post.title}</h1>
          <div className="blog-meta">
            <span className="blog-date">{displayDate(post)}</span>
            {post.author && <span className="blog-author">by {post.author}</span>}
          </div>
        </header>
        <div className="blog-content">
          <ReactMarkdown>{post.content}</ReactMarkdown>
        </div>
      </article>

      <Comments postSlug={post.slug} />
    </>
  );
};

export default BlogPost;
